import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/practitionersApi'
import { patientGet } from './patientApi'

const BASE = '/api/secure/me/practitioners'
const CTX = { requirePatientContext: true }

export async function list(profile) {
  if (shouldUseMocks()) return mock.listPractitioners(profile)
  const res = await patientGet(BASE, CTX)
  return res?.data || []
}

export async function get(profile, id) {
  if (shouldUseMocks()) return mock.getPractitioner(profile, id)
  const res = await patientGet(`${BASE}/${encodeURIComponent(id)}`, CTX)
  return res?.data || null
}

/**
 * Paged patient × practitioner session history. status accepts
 * "upcoming" / "past" / undefined (= all). Used by the "View past
 * appointments" affordance on the practitioner detail page.
 */
export async function listSessions(profile, id, { status, page = 1, pageSize = 20 } = {}) {
  if (shouldUseMocks()) return mock.listPractitionerSessions ? mock.listPractitionerSessions(profile, id, { status, page, pageSize }) : []
  const params = new URLSearchParams()
  if (status) params.set('status', status)
  if (page) params.set('page', String(page))
  if (pageSize) params.set('pageSize', String(pageSize))
  const qs = params.toString()
  const url = `${BASE}/${encodeURIComponent(id)}/sessions${qs ? `?${qs}` : ''}`
  const res = await patientGet(url, CTX)
  return res?.data || []
}
